module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page services",
    class: {
      init: _vm.isInit
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "row center-xs contact-btn"
  }, [_c('div', {
    staticClass: "col-md-9 col-xs-12 text-center"
  }, [_c('router-link', {
    staticClass: "next",
    attrs: {
      "to": "/contact"
    }
  }, [_c('span', [_vm._v("Connect to Create")])]), _vm._v(" "), _c('span', {
    staticClass: "line"
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "scroll-btn"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 477.175 477.175"
    },
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 477.175 477.175",
      "xml:space": "preserve"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "d": "M360.731,229.075l-225.1-225.1c-5.3-5.3-13.8-5.3-19.1,0s-5.3,13.8,0,19.1l215.5,215.5l-215.5,215.5c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4c3.4,0,6.9-1.3,9.5-4l225.1-225.1C365.931,242.875,365.931,234.275,360.731,229.075z"
    }
  })])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row center-xs"
  }, [_c('div', {
    staticClass: "col-md-9 col-xs-12 text-center first"
  }, [_c('span', [_vm._v("360")]), _vm._v(" "), _c('h1', [_vm._v("SOLUTIONS")]), _vm._v(" "), _c('p', [_vm._v("We’re making exploration easy through our focused digital only approach designed to elevate your brand from the clutter.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row center-xs split"
  }, [_c('div', {
    staticClass: "col-md-9 col-xs-12"
  }, [_c('div', {
    staticClass: "row middle-xs"
  }, [_c('div', {
    staticClass: "col-sm-4 col-xs-12"
  }, [_c('img', {
    attrs: {
      "src": require("../img/services-strategy.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8 col-xs-12 text-left"
  }, [_c('h2', [_vm._v("Strategy")]), _vm._v(" "), _c('p', [_vm._v("Research-driven strategy that leads to result-driven solutions. We are in constant competition with ourselves to get you more bang for your buck.")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row center-xs split"
  }, [_c('div', {
    staticClass: "col-md-9 col-xs-12"
  }, [_c('div', {
    staticClass: "row middle-xs"
  }, [_c('div', {
    staticClass: "col-sm-8 col-xs-12 text-left"
  }, [_c('h2', [_vm._v("Social Media Marketing")]), _vm._v(" "), _c('p', [_vm._v("We deliver content that matters to the consumers and boost engagement metrics that matter for your brand. We specialize in sparking honest, engaging dialogues online.")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 col-xs-12"
  }, [_c('img', {
    attrs: {
      "src": require("../img/services-social.png")
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row center-xs split"
  }, [_c('div', {
    staticClass: "col-md-9 col-xs-12"
  }, [_c('div', {
    staticClass: "row middle-xs"
  }, [_c('div', {
    staticClass: "col-sm-4 col-xs-12"
  }, [_c('img', {
    attrs: {
      "src": require("../img/services-branding.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8 col-xs-12 text-left"
  }, [_c('h2', [_vm._v("Branding")]), _vm._v(" "), _c('p', [_vm._v("We believe branding should be like coffee – strong, hot and addictive. Our strategy-driven branding process makes sure your brand meets all 3 requirements.")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row center-xs split"
  }, [_c('div', {
    staticClass: "col-md-9 col-xs-12"
  }, [_c('div', {
    staticClass: "row middle-xs"
  }, [_c('div', {
    staticClass: "col-sm-8 col-xs-12 text-left"
  }, [_c('h2', [_vm._v("Content Creation")]), _vm._v(" "), _c('p', [_vm._v("We believe in crafting content that bridges the gap between you and your audience, transforming potential buyers into enthusiastic customers. For us, powerful punchlines and creative memes are a means to get there, not an end by themselves.")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 col-xs-12"
  }, [_c('img', {
    attrs: {
      "src": require("../img/services-content.png")
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row center-xs split"
  }, [_c('div', {
    staticClass: "col-md-9 col-xs-12"
  }, [_c('div', {
    staticClass: "row middle-xs"
  }, [_c('div', {
    staticClass: "col-sm-4 col-xs-12"
  }, [_c('img', {
    attrs: {
      "src": require("../img/services-website.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8 col-xs-12 text-left"
  }, [_c('h2', [_vm._v("Website Development")]), _vm._v(" "), _c('p', [_vm._v("We make your website look like a ballerina but work like a horse. We focus on developing interfaces that delight, backed by solid developing skills.")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row center-xs split"
  }, [_c('div', {
    staticClass: "col-md-9 col-xs-12"
  }, [_c('div', {
    staticClass: "row middle-xs"
  }, [_c('div', {
    staticClass: "col-sm-8 col-xs-12 text-left"
  }, [_c('h2', [_vm._v("Search Engine Optimisation")]), _vm._v(" "), _c('p', [_vm._v("Get on the digital podium with straight up tangible results. Maximise your brand visibility on the most visited site - Google.")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 col-xs-12"
  }, [_c('img', {
    attrs: {
      "src": require("../img/services-search.png")
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row center-xs split"
  }, [_c('div', {
    staticClass: "col-md-9 col-xs-12"
  }, [_c('div', {
    staticClass: "row middle-xs"
  }, [_c('div', {
    staticClass: "col-sm-4 col-xs-12"
  }, [_c('img', {
    attrs: {
      "src": require("../img/services-digital.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8 col-xs-12 text-left"
  }, [_c('h2', [_vm._v("Digital Marketing")]), _vm._v(" "), _c('p', [_vm._v(" There are 3 magic words in digital marketing – target, remarket and sell - and we know how to get the best out of all three.")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row center-xs last"
  }, [_c('div', {
    staticClass: "col-md-9 col-xs-12"
  }, [_c('p', [_vm._v("If you’re looking for fresh and impactful solutions,"), _c('br'), _vm._v("we’re your guys.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62acaef1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Services.vue
// module id = 162
// module chunks = 0